<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {FunnelPath} from "@/path";
import Swal from "sweetalert2";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Funnel Data Import",
      items: [
        {
          text: "Funnel",
        },
        {
          text: "Import",
          active: true,
        },
      ],
      date : null,
      file : null,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    };
  },
  methods : {
    async savePolicy(){
      try {
        if(this.date == null){
            Swal.fire('Please Select Date','','error');
            return;
        }
        let formData = new FormData();
        formData.append('date',this.date);
        formData.append('file',this.file);
        let res = await axios.post(this.baseUrl + FunnelPath.FUNNEL_IMPORT,formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(res.data.status){
          Swal.fire('success','','success');
          location.reload();
        }
      }catch (err){
        console.log(err);
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-body>
        <b-form-group>
          <label>Date</label>
          <b-datepicker v-model="date"></b-datepicker>
        </b-form-group>
        <b-form-group>
          <label>Csv File Upload</label>
          <b-form-file accept=".csv" @change="((e) => file = e.target.files[0])"></b-form-file>
        </b-form-group>
        <b-form-group>
          <b-button variant="success" @click="savePolicy">Submit</b-button>
        </b-form-group>
      </b-card-body>
    </b-card>
  </Layout>
</template>
